//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
export default {
  layout: 'error',
  props: {
    error: {
      type: Object,
      default() {
        return {
          statusCode: 404,
          message: 'noContent',
        }
      },
    },
  },
  data() {
    return {
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-hear-02.svg?data`),
          width: 157,
          height: 135,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-connect-06.svg?data`),
          width: 95,
          height: 143,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 164,
          height: 139,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 476,
          alt: '',
        },
      ],
    }
  },
  computed: {
    title() {
      return this.$store.getters['locale/getTranslations'][this.error.message]
    },
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
}
